import React, { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import citiesAndDelegations from '../data/citiesAndDelegations.js';
const EditAddressForm = lazy(() => import('./EditAddressForm'));

const SectionInformation = ({ formData, setFormData, onChange, optionalPrice = false, geographicSearch = false }) => {
  const { t } = useTranslation();
  
  // const onChange = (e) => {
  // const value = e.target.value === "true" ? true : e.target.value === "false" ? false : e.target.value;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [e.target.id]: value,
  //   }));
  // };

  return (
    <div className="mb-6">
      <h3 className="mb-4 text-xl font-semibold">{t('localize_property')}</h3>

      {geographicSearch ? <Suspense fallback={<p>{t('loading')}</p>}><EditAddressForm formData={formData} setFormData={setFormData} /></Suspense> : <>
      {/* Adresse */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-lg font-semibold" htmlFor="adresse">
            {t('address')}
          </label>
          <input
            required
            id="adresse"
            type="text"
            value={formData.adresse || ""}
            onChange={onChange}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          />
        </div>
        <div>
          <label className="block text-lg font-semibold" htmlFor="codePostal">
            {t('postal_code')}
          </label>
          <input
            type="text"
            id="codePostal"
            maxLength={4}
            value={formData.codePostal || ""}
            onChange={onChange}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          />
        </div>
      </div>

      {/* Ville et Délégation */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-lg font-semibold" htmlFor="ville">
            {t('city')}
          </label>
          <select
            required
            id="ville"
            value={formData.ville}
            onChange={(e) => {
              onChange(e);
              setFormData((prevData) => ({
                ...prevData,
                delegation: "", // Réinitialiser la délégation lorsque la ville change
              }));
            }}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          >
            <option value="" disabled>
              {t('select_city')}
            </option>
            {Object.keys(citiesAndDelegations).map((ville) => (
              <option key={ville} value={ville}>
                {t(`cities.${ville}`)}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-lg font-semibold" htmlFor="delegation">
            {t('delegation')}
          </label>
          <select
            required
            id="delegation"
            value={formData.delegation}
            onChange={onChange}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          >
            <option value="" disabled>
              {t('select_delegation')}
            </option>
            {citiesAndDelegations[formData.ville]?.map((delegation) => (
              <option key={delegation} value={delegation}>
                {t(`delegations.${formData.ville}.${delegation}`)}
              </option>
            ))}
          </select>
        </div>
      </div>

      </>}
      {/* Section Prix */}
      <p className="text-lg mt-6 font-semibold">{t('offer')}</p>
      <div className="flex mb-1">
        <button
          type="button"
          id="offre"
          value={true}
          onClick={onChange}
          className={`me-3 px-7 py-3 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg focus:shadow-lg transition duration-150 ease-in-out w-full ${
            formData.offre ? "bg-slate-600 text-white" : "bg-white text-black"
          }`}
        >
          {t('yes')}
        </button>
        <button
          type="button"
          id="offre"
          value={false}
          onClick={onChange}
          className={`ms-3 px-7 py-3 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg focus:shadow-lg transition duration-150 ease-in-out w-full ${
            !formData.offre ? "bg-slate-600 text-white" : "bg-white text-black"
          }`}
        >
          {t('no')}
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <p className="text-lg font-semibold">{t('price')}</p>
          <input
            required={!optionalPrice}
            type="number"
            id="prix"
            value={optionalPrice && Number(formData.prix) === 0 ? "" : formData.prix ?? ""}
            onChange={onChange}
            min="0"
            max="50000000"
            className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded text-center mb-1"
          />
        </div>
        {formData.offre && (
          <div>
            <p className="text-lg font-semibold">{t('offer')}</p>
            <input
              type="number"
              id="prixReduit"
              value={formData.prixReduit ?? ""}
              onChange={onChange}
              min="0"
              max="50000000"
              className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded text-center mb-1"
            />
          </div>
        )}
      </div>

      {/* Section Contact */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-lg font-semibold" htmlFor="email">
            {t('email')}
          </label>
          <input
            required
            type="email"
            id="email"
            value={formData.email}
            onChange={onChange}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          />
        </div>
        <div>
          <label className="block text-lg font-semibold" htmlFor="tel">
            {t('listing.phone')}
          </label>
          <input
            required
            type="tel"
            id="tel"
            maxLength={8}
            value={formData.tel}
            onChange={onChange}
            className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
          />
        </div>
      </div>

    </div>
  );
};

export default SectionInformation;
